// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"488":"61dadfbb","611":"4dfb8e18"}[chunkId] + ".css";
};